const carouselItems = [
  {
    title: '顶流塌房启示录：2025娱乐圈大洗牌',
    desc: '从税务风波到私生活争议，多位顶流艺人在今年集体翻车。17吃瓜网深度解析背后的资本博弈与行业变局。',
    badge: '深度专题',
    gradient: 'from-primary-500/90 to-primary-700/95',
  },
  {
    title: '网红经济泡沫：当流量红利褪去之后',
    desc: '百万粉丝网红的真实收入揭秘，17吃瓜黑料网独家调查网红行业的残酷真相与生存法则。',
    badge: '行业调查',
    gradient: 'from-accent-600/90 to-accent-800/95',
  },
  {
    title: '幕后推手：娱乐圈公关团队操作内幕',
    desc: '偷拍、通稿、水军、控评——还原明星爆料背后的完整公关产业链，17黑料吃瓜带你认识真正的娱乐圈。',
    badge: '独家揭秘',
    gradient: 'from-secondary-600/90 to-secondary-700/95',
  },
  {
    title: '吃瓜群众心理健康指南：理性追瓜不焦虑',
    desc: '在17c吃瓜黑料爆料信息洪流中保持清醒，如何健康地参与内幕吃瓜而不陷入负面情绪循环。',
    badge: '特别企划',
    gradient: 'from-primary-600/90 to-accent-700/95',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            深度专题
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 特别策划栏目</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className={`rounded-xl bg-gradient-to-br ${item.gradient} p-6 md:p-7 min-h-[260px] md:min-h-[300px] flex flex-col justify-end cursor-pointer transition-all duration-300 hover:scale-[1.02] relative overflow-hidden`}
            >
              <div className="absolute top-4 right-4 w-16 h-16 rounded-full bg-background-50/10 blur-xl pointer-events-none"></div>
              <div className="relative z-10">
                <span className="inline-block px-2.5 py-1 rounded-md bg-background-50/20 text-background-50 text-[10px] md:text-xs font-medium mb-3 whitespace-nowrap">
                  {item.badge}
                </span>
                <h3 className="font-heading font-bold text-base md:text-lg text-background-50 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-background-50/75 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}